import { $, $$, YO, alcance, aviso, avisoHtml, el, esc, fecha, limpiar, noContesto, num, pedir,
         puede, rpc, rpcLee, sb, tengoRol } from './nucleo';
import { ERROR_PRODUCTOS, PRODUCTOS } from './catalogo';
import { ERROR_ZONAS, asegurarZonas, zonasLeidas } from './clientes';
import { RECHAZO_DESCUENTO, RECHAZO_DESCUENTO_PEDIDO, cargarAprobaciones, ofrecerPedirCorte } from './aprobaciones';
import { cargarPedidos } from './pedidos';
import { irACobros } from './cobros';
import { abrirComoFicha, cerrarComoFicha } from './navegacion';

//  LA FICHA DE LA VENTA (D220, migración 0101). Se entra con el código del
//  pedido y se ve lo que tiene: cabecera, productos con su paso y su serie,
//  cobros e historial. Se trabaja desde ahí según la situación de la venta,
//  que la dice la base (`situacion_del_pedido`): la pantalla sólo esconde lo
//  que no va; cada puerta vuelve a mirar todo (D11).
//
//    · intacta      — productos (agregar, quitar, descuento), prioridad,
//                     envío y notas.
//    · en_deposito  — envío y notas.
//    · en_la_calle, terminada — sólo notas.
//    · anulada      — nada.

let FP: any = null;          //  la ficha abierta: { id, ped, items, sit }
let TURNO = 0;               //  una lectura vieja no pisa la ficha de otro pedido

const SITUACION: Record<string, string> = {
  intacta: 'El depósito todavía no tocó nada: se pueden agregar y quitar productos, cambiar el descuento, la prioridad, el envío y las notas.',
  en_deposito: 'El depósito ya empezó: se cambian los datos de envío y las notas, y un producto se anula desde su renglón.',
  en_la_calle: 'Ya hay algo en la calle o entregado: de los datos, sólo las notas.',
  terminada: 'La venta está terminada: de los datos, sólo las notas.',
  anulada: 'La venta está anulada: no se cambia nada.',
};
const CHIP_PED: Record<string, string> = { activo:'c-pen', finalizado:'c-ok', anulado:'c-bad', borrador:'c-warn' };

//  Quién puede tocar la venta: lo mismo que pregunta `app.pedido_para_editar`.
const edita = (p: any) => puede('pedido','editar')
  && (alcance('pedido','editar') === 'todos' || p.vendedor_id === YO?.id
      || tengoRol('admin', 'admin_global', 'dueno'));

//  La ficha ocupa la pestaña y vuelve a la lista con «← Volver», con el
//  «atrás» del navegador o al cambiar de pestaña (D231, `navegacion.ts`).
function mostrarFicha(ver: boolean){
  if (ver) abrirComoFicha($('#fichaPed'), { lista: 'la lista', nombre: 'la venta',
    boton: $('#fpVolver'), alCerrar: limpiarVenta });
  else cerrarComoFicha($('#fichaPed'));
}

//  Las preguntas abiertas («Quitar», «Anular») y la tarjeta del corte viven
//  fuera de la tabla: se van al salir de la venta, o su «Sí» actuaría sobre
//  un producto de otro pedido.
function cerrarPreguntas(){
  for (const id of ['fpConfQuitar', 'fpConfAnular', 'fpCorte', 'fpPedirDesc', 'fpConfCancelar', 'fpCancCorte', 'fpPedirCanc'])
    document.getElementById(id)?.remove();
  CORTE_ANULAR = null;
}
let CORTE_ANULAR: { item: number, estado: string } | null = null;

//  También al entrar a la pestaña por el menú: se llega a la lista.
function limpiarVenta(){
  cerrarPreguntas();
  FP = null;
  TURNO++;
}
export function cerrarVenta(){
  limpiarVenta();
  mostrarFicha(false);
}

export async function abrirVenta(id: number){
  const turno = ++TURNO;
  for (const s of ['#fpMsg', '#fpItemsMsg', '#fpAgrMsg', '#fpGuardarMsg', '#fpHistMsg', '#fpCancelarMsg'])
    limpiar(s);
  cerrarPreguntas();
  $('#fpTitulo').textContent = 'Pedido';
  $('#fpChips').innerHTML = ''; $('#fpResumen').innerHTML = ''; $('#fpSituacion').textContent = '';
  $('#tblFpItems').innerHTML = ''; $('#fpCobros').innerHTML = ''; $('#fpHist').innerHTML = '';
  $('#formFp').classList.add('oculto');
  $('#fpAgregar').classList.add('oculto');
  $('#fpCancelarFila').classList.add('oculto');
  FP = { id };
  mostrarFicha(true);
  window.scrollTo({ top: 0 });
  await leerVenta(turno);
}

async function leerVenta(turno: number){
  const id = FP.id;
  const [cab, ped, its, sit, tr] = await Promise.all([
    pedir(sb.from('v_pedidos').select('*').eq('id', id)),
    pedir(sb.from('pedidos').select('id,codigo,vendedor_id,estado,prioridad,notas,direccion,barrio,zona_id,telefono_contacto,horario_texto,costo_envio').eq('id', id)),
    pedir(sb.from('v_items_pedido').select('*').eq('pedido_id', id).order('id')),
    rpcLee('situacion_del_pedido', { p_pedido_id: id }),
    //  Qué pasos puede dar cada uno con un producto (la base recorta por rol):
    //  de acá salen «Anular» y «Cancelar», los mismos que en Circuito.
    pedir(sb.from('v_transiciones_posibles').select('*'))]);
  if (turno !== TURNO) return;
  const error = cab.error || ped.error || its.error || sit.error;
  //  Sin todo lo que la venta tiene no se trabaja sobre ella (D79).
  if (error){
    aviso('#fpMsg', 'bad', `No se pudo leer el pedido (${error.message}). ` +
      'Volvé a la lista y entrá de nuevo, o recargá con Ctrl+F5.');
    return;
  }
  const c = (cab.data || [])[0], p = (ped.data || [])[0];
  if (!c || !p){
    aviso('#fpMsg', 'warn', 'Este pedido ya no está entre los que podés ver.');
    return;
  }
  FP = { id, cab: c, ped: p, items: its.data || [], sit: sit.data as unknown as string,
         trans: tr.error ? null : (tr.data || []), errTrans: tr.error?.message || '' };
  pintarCabecera();
  pintarItems();
  pintarDatos();
  leerCobros(turno);
  leerHistorial(turno);
}

function pintarCabecera(){
  const c = FP.cab;
  $('#fpTitulo').textContent = `Pedido ${c.codigo}`;
  $('#fpChips').innerHTML = `<span class="chip ${CHIP_PED[c.estado] || 'c-pen'}">${esc(c.estado)}</span>${
    c.prioridad === 'urgente' ? ' <span class="chip c-bad">urgente</span>' : ''}${
    c.items_faltantes ? ` <span class="chip c-warn">${c.items_faltantes} falta</span>` : ''}`;
  const saldo = Number(c.saldo || 0);
  $('#fpResumen').innerHTML = `
    <div><div class="hint">Cliente</div><b>${esc(c.cliente || 'no lo ves')}</b></div>
    <div><div class="hint">Vendedor</div>${esc(c.vendedor || '—')}</div>
    <div><div class="hint">Fecha</div>${esc(fecha(c.ocurrido_en))}</div>
    <div><div class="hint">Entrega</div>${esc(c.metodo_entrega || '—')}${
      FP.ped.direccion ? `<div class="hint">${esc(FP.ped.direccion)}</div>` : ''}</div>
    <div><div class="hint">Total</div><b id="fpTotal">${num(Number(c.neto || 0))}</b></div>
    <div><div class="hint">Cobrado</div>${num(Number(c.cobrado || 0))}<div class="hint" id="fpSaldo">${
      saldo > 0.005 ? `Falta cobrar ${num(saldo)}`
      : saldo < -0.005 ? `<b>${num(-saldo)} a favor del cliente</b> (no se reintegra solo)` : 'Cobrado entero'}</div></div>`;
  //  Cancelar la venta entera (D222): quien la edita, mientras no esté
  //  anulada. Lo demás (en la calle, entregado, plata) lo dice la base.
  $('#fpCancelarFila').classList.toggle('oculto', !(edita(FP.ped) && FP.sit !== 'anulada'));
  $('#fpSituacion').textContent = (SITUACION[FP.sit] || '') +
    (edita(FP.ped) ? '' : ' Los datos de esta venta no los podés cambiar: los cambia su vendedor o un administrador.');
}

//  Los productos. Con la venta intacta y permiso, cada renglón tiene su
//  descuento editable y su «Quitar».
function pintarItems(){
  const abierta = FP.sit === 'intacta' && edita(FP.ped);
  if (CORTE_ANULAR){
    const sigue = FP.items.find((x: any) => x.id === CORTE_ANULAR!.item);
    if (!sigue || sigue.estado !== CORTE_ANULAR.estado){
      document.getElementById('fpCorte')?.remove();
      CORTE_ANULAR = null;
    }
  }
  $('#tblFpItems').innerHTML = FP.items.map((i: any) => `
    <tr data-item="${i.id}">
      <td><span class="mono">${esc(i.producto)}</span> ${esc(i.descripcion)}</td>
      <td class="num">${i.cantidad}</td>
      <td class="num">${num(Number(i.precio_unitario))}</td>
      <td class="num">${abierta && i.estado !== 'cancelado'
        ? `<input type="number" step="0.01" min="0" data-desc="${i.id}" value="${Number(i.descuento)}" style="width:6rem">
           <button class="b b-sec" type="button" data-guardadesc="${i.id}">Cambiar</button>`
        : Number(i.descuento) ? num(Number(i.descuento)) : '—'}</td>
      <td class="num"><b>${num(Number(i.neto))}</b></td>
      <td><span class="chip" style="background:${esc(i.color || '')}22">${esc(i.estado_nombre)}</span></td>
      <td class="mono">${esc(i.serie || '—')}</td>
      <td><div class="fila-acc">${abierta && i.estado !== 'cancelado'
        ? `<button class="b b-sec" type="button" data-quitar="${i.id}">Quitar</button>` : anularDe(i)}</div></td>
    </tr>`).join('') || '<tr><td colspan="8" class="vacio">Este pedido no tiene productos.</td></tr>';
  $('#fpAgregar').classList.toggle('oculto', !abierta);
  if (abierta) pintarProductos();
}

//  ANULAR UN PRODUCTO DESDE LA VENTA (D221). Lo que el depósito ya tocó no
//  se quita (no se borra): se anula, por la misma puerta que en Circuito
//  (`cambiar_estado_item`), con los mismos pasos que la base le da a cada
//  rol (`v_transiciones_posibles`) y lo que cada paso exige (motivo, el
//  corte, la revisión de lo entregado). Lo que no se tocó, en una venta que
//  ya no está intacta, se cancela igual que en Circuito.
const BAJAS = ['anulado', 'cancelado'];
function bajasDe(i: any): any[] {
  if (!FP.trans) return [];
  const vistos = new Set<string>();
  return FP.trans.filter((t: any) => t.desde === i.estado && BAJAS.includes(t.hasta) &&
    (!t.aplica_tipo || !i.tipo_entrega || t.aplica_tipo === i.tipo_entrega) &&
    !vistos.has(t.hasta) && vistos.add(t.hasta));
}
function anularDe(i: any): string {
  if (BAJAS.includes(i.estado) || i.es_final && i.estado !== 'entregado') return '';
  //  Sin la lista no se sabe qué se puede: no es lo mismo que no poder nada.
  if (!FP.trans) return '<span class="hint">no se pudo leer qué se puede hacer</span>';
  return bajasDe(i).map(t => `<button class="b b-peligro" type="button" data-anular="${i.id}"
      data-a="${esc(t.hasta)}">${t.hasta === 'anulado' ? 'Anular' : 'Cancelar'}</button>`).join('');
}

function pintarProductos(){
  const elegido = $('#fpProd').value;
  $('#fpProd').innerHTML = ERROR_PRODUCTOS
    ? '<option value="">no se pudieron leer los productos</option>'
    : '<option value="">— elegí el producto —</option>' +
      PRODUCTOS.map((p: any) => `<option value="${p.id}">${esc(p.codigo)} — ${esc(p.descripcion)}</option>`).join('');
  if (elegido) $('#fpProd').value = elegido;
  $('#fpBtnAgregar').disabled = !!ERROR_PRODUCTOS;
  sugerirPrecio();
}
function sugerirPrecio(){
  const p: any = PRODUCTOS.find((x: any) => x.id === Number($('#fpProd').value));
  $('#fpPrecio').value = !p ? '' : p.precio_vigente != null ? num(p.precio_vigente) : 'sin precio de lista';
}
$('#fpProd').onchange = sugerirPrecio;

//  Después de cada cambio: la ficha de nuevo (el total, la situación y el
//  historial los dice la base) y la lista de atrás.
async function releer(){
  if (!FP) return;
  cargarPedidos();
  await leerVenta(TURNO);
}

$('#fpBtnAgregar').onclick = async () => {
  limpiar('#fpAgrMsg');
  document.getElementById('fpPedirDesc')?.remove();
  const prod = Number($('#fpProd').value);
  if (!prod){ aviso('#fpAgrMsg', 'bad', 'Elegí un producto.'); return; }
  //  Entero: la base recibe `int` (D220).
  const cant = Math.max(1, Math.floor(Number($('#fpCant').value) || 1));
  const desc = Number($('#fpDesc').value) || 0;
  const b = $('#fpBtnAgregar'); b.disabled = true;
  const { data, error } = await rpc('agregar_item_pedido', {
    p_pedido_id: FP.id, p_producto_id: prod, p_cantidad: cant, p_descuento: desc });
  //  Si no contestó, quizá quedó agregado (D92): el botón queda apagado hasta releer.
  if (noContesto(error)){
    aviso('#fpAgrMsg', 'warn', error.message + ' Fijate en la lista de productos antes de agregarlo de nuevo.');
    releer();
    return;
  }
  b.disabled = false;
  if (error){
    aviso('#fpAgrMsg', 'bad', error.message);
    //  El corte: la misma autorización que un pedido nuevo («carga»).
    if (!ofrecerPedirCorte({ despuesDe: '#fpAgrMsg', id: 'fpCorte', prefijo: 'fpCorte',
          mensaje: error.message, refTipo: 'carga', refId: null,
          comoSigue: 'Cuando te la den, volvé a apretar «Agregar a la venta».' }))
      ofrecerPedirDescuento('#fpAgrMsg', error.message, prod, desc, null);
    return;
  }
  document.getElementById('fpCorte')?.remove();
  $('#fpCant').value = '1'; $('#fpDesc').value = '0'; $('#fpProd').value = ''; sugerirPrecio();
  await releer();
  aviso('#fpAgrMsg', 'ok', data.mensaje);
};

$('#tblFpItems').onclick = async e => {
  const q = el(e.target).closest('[data-quitar]');
  if (q) return confirmarQuitar(Number(q.dataset.quitar));
  const a = el(e.target).closest('[data-anular]');
  if (a) return confirmarAnular(Number(a.dataset.anular), a.dataset.a);
  const g = el(e.target).closest('[data-guardadesc]');
  if (g) return cambiarDescuento(Number(g.dataset.guardadesc));
};

//  Quitar BORRA el producto de la venta (Steven, 2/11): se pregunta antes.
function confirmarQuitar(itemId: number){
  const it = FP.items.find((x: any) => x.id === itemId);
  if (!it) return;
  document.getElementById('fpConfQuitar')?.remove();
  limpiar('#fpItemsMsg');
  const cobrado = Number(FP.cab.cobrado || 0) > 0.005;
  $('#fpItemsMsg').insertAdjacentHTML('beforebegin', `
    <div class="confirmar grave" id="fpConfQuitar" style="margin-top:0.471rem">
      <div class="conf-tit">¿Quitar ${esc(it.producto)} de la venta?</div>
      <p class="conf-txt">Se borra de la venta (queda anotado en el historial).${cobrado
        ? ' <b>Esta venta tiene plata cobrada:</b> si con esto se cobró de más, queda a favor del cliente y no se le devuelve solo.' : ''}</p>
      <div class="fila-acc">
        <button class="b b-sec" type="button" id="fpQuitarNo">No</button>
        <button class="b b-pri" type="button" id="fpQuitarSi">Sí, quitarlo</button>
      </div>
    </div>`);
  $('#fpQuitarNo').onclick = () => document.getElementById('fpConfQuitar')?.remove();
  $('#fpQuitarSi').onclick = async () => {
    $('#fpQuitarSi').disabled = true;
    const { data, error } = await rpc('quitar_item_pedido', { p_item_id: itemId });
    document.getElementById('fpConfQuitar')?.remove();
    if (noContesto(error)){
      aviso('#fpItemsMsg', 'warn', error.message + ' Fijate en la lista antes de volver a quitarlo.');
      releer();
      return;
    }
    if (error){
      aviso('#fpItemsMsg', 'bad', error.message);
      ofrecerPedirCorte({ despuesDe: '#fpItemsMsg', id: 'fpCorte', prefijo: 'fpCorte',
        mensaje: error.message, refTipo: 'pedido_item', refId: itemId,
        comoSigue: 'Cuando te la den, volvé a apretar «Quitar».' });
      return;
    }
    document.getElementById('fpCorte')?.remove();
    await releer();
    //  Con plata cobrada de más, el aviso es amarillo y lo dice clarito.
    aviso('#fpItemsMsg', Number(data.a_favor || 0) > 0 ? 'warn' : 'ok', data.mensaje);
  };
}

//  La pregunta antes de anular: qué pasa con el producto, el motivo (lo
//  exige el paso) y, si ya se entregó, cuánto se cobró y la casilla de que
//  la plata se devuelve aparte (como en Circuito, D183).
async function confirmarAnular(itemId: number, hasta: string){
  const it = FP.items.find((x: any) => x.id === itemId);
  const t = it && bajasDe(it).find((x: any) => x.hasta === hasta);
  if (!t) return;
  document.getElementById('fpConfAnular')?.remove();
  document.getElementById('fpConfQuitar')?.remove();
  document.getElementById('fpCorte')?.remove();
  limpiar('#fpItemsMsg');
  const revisar = !!t.exige_revision;
  const anula = hasta === 'anulado';
  const id = FP.id;
  let cobrado: any = null;
  if (revisar){
    const { data } = await rpcLee('cobrado_del_item', { p_item_id: itemId });
    if (FP?.id !== id) return;
    cobrado = data;
    //  Mientras se leía, pudo abrirse otra pregunta: queda una sola.
    document.getElementById('fpConfAnular')?.remove();
    document.getElementById('fpConfQuitar')?.remove();
  }
  const explico = revisar
    ? `<b>Esto ya se entregó.</b> Sacarlo NO devuelve la plata: después hay que anular el cobro
       (abajo, «Ir a cobrar»). El equipo sigue afuera hasta que alguien lo marque Devuelto.`
    : anula
    ? `El producto sale de la venta pero <b>sigue apartado</b>: no se puede vender
       hasta que alguien lo marque Devuelto, que es cuando vuelve a su lugar.`
    : 'El producto queda cancelado en la venta (no se borra: el depósito ya empezó con ella).';
  const verbo = anula ? 'anular' : 'cancelar';
  $('#fpItemsMsg').insertAdjacentHTML('beforebegin', `
    <div class="confirmar grave" id="fpConfAnular" style="margin-top:0.471rem">
      <div class="conf-tit">¿${anula ? 'Anular' : 'Cancelar'} ${esc(it.producto)}?</div>
      <p class="conf-txt">${explico}</p>
      ${it.serie ? `<p class="conf-txt">Salió con la serie <b class="mono">${esc(it.serie)}</b>.</p>` : ''}
      ${revisar ? `<p class="conf-txt">Cobrado de este pedido: <b>${cobrado == null ? 'no se pudo leer'
          : !Number(cobrado.pagos || 0) || !cobrado.detalle ? 'nada registrado' : esc(cobrado.detalle)}</b></p>
        <div class="chips-form"><label><input type="checkbox" id="fpAnRevisado">
          Entendí: la plata se devuelve aparte</label></div>` : ''}
      ${t.exige_motivo ? `<label>Motivo <input id="fpAnMotivo"
          placeholder="Por qué se ${verbo} (queda registrado)" autocomplete="off"></label>` : ''}
      <div class="fila-acc" style="margin-top:0.471rem">
        <button class="b b-sec" type="button" id="fpAnNo">No</button>
        <button class="b b-peligro" type="button" id="fpAnSi">Sí, ${verbo}</button>
      </div>
      <div id="fpAnMsg"></div>
    </div>`);
  $('#fpAnMotivo')?.focus();
  $('#fpAnNo').onclick = () => document.getElementById('fpConfAnular')?.remove();
  $('#fpAnSi').onclick = async () => {
    const motivo = t.exige_motivo ? (($('#fpAnMotivo').value || '').trim() || null) : null;
    if (t.exige_motivo && !motivo){ aviso('#fpAnMsg', 'bad', 'Escribí el motivo.'); return; }
    if (revisar && !$('#fpAnRevisado').checked){
      aviso('#fpAnMsg', 'bad', 'Tildá la casilla del cobro antes de confirmar.'); return;
    }
    $('#fpAnSi').disabled = true;
    const { data, error } = await rpc('cambiar_estado_item', {
      p_item_id: itemId, p_estado: hasta, p_motivo: motivo,
      p_unidad_id: null, p_confirmado: revisar });
    if (FP?.id !== id) return;
    document.getElementById('fpConfAnular')?.remove();
    if (noContesto(error)){
      aviso('#fpItemsMsg', 'warn', error.message + ' Fijate en la lista antes de volver a intentarlo.');
      releer();
      return;
    }
    if (error){
      aviso('#fpItemsMsg', 'bad', error.message);
      //  El corte: la autorización ahí mismo, sobre el renglón (D219).
      if (ofrecerPedirCorte({ despuesDe: '#fpItemsMsg', id: 'fpCorte', prefijo: 'fpCorte',
        mensaje: error.message, refTipo: 'pedido_item', refId: itemId,
        comoSigue: `Cuando te la den, volvé a apretar «${anula ? 'Anular' : 'Cancelar'}».` }))
        CORTE_ANULAR = { item: itemId, estado: it.estado };
      //  Como Circuito: si otro lo movió, los botones se ponen al día (y la
      //  tarjeta se va, D108).
      releer();
      return;
    }
    await releer();
    aviso('#fpItemsMsg', revisar ? 'warn' : 'ok', data.mensaje +
      (data.pedido_cerrado ? ' El pedido quedó cerrado.' : '') +
      (revisar ? ' La plata no se devolvió: anulá el cobro desde «Ir a cobrar».' : ''));
  };
}

// ---------- cancelar la venta entera (0102, D222) ----------
//  Las frases de la base que traen su tarjeta de autorización (cotejadas
//  en `scripts/cotejar-catalogos.py`).
export const RECHAZO_VENTA_COBRADA = 'cancelarla necesita la aprobación de un administrador';
export const RECHAZO_CANCELAR_RESERVA = 'Cancelar una reserva requiere aprobación';

$('#fpBtnCancelar').onclick = () => {
  if (!FP?.cab) return;
  cerrarPreguntas();
  limpiar('#fpCancelarMsg');
  const c = FP.cab;
  const cobrado = Number(c.cobrado || 0);
  const entregados = FP.items.filter((i: any) => i.estado === 'entregado').map((i: any) => i.producto);
  const enCalle = FP.items.filter((i: any) => i.estado === 'en_transito').map((i: any) => i.producto);
  const conPlata = cobrado > 0.005 || entregados.length > 0;
  //  Si se borra o se anula lo decide la base (también mira los cobros
  //  anulados, las vueltas, la cuenta y la reserva): acá se dice lo probable.
  const seBorra = FP.sit === 'intacta' && cobrado <= 0.005;
  const explico = enCalle.length
    ? `<b>No se puede cancelar entera:</b> ${esc(enCalle.join(', '))} está en la calle. Cuando vuelva o se entregue, se puede.`
    : seBorra
    ? `El depósito no tocó nada: la venta <b>se borra entera</b> (queda el rastro en Actividad).
       Si ya tuvo cobros, está en una vuelta o es una reserva, no se borra: se anula.`
    : `A cada producto su paso: lo que el depósito no tocó queda <b>Cancelado</b>; lo separado,
       empaquetado o entregado, <b>Anulado</b> (vuelve a su lugar cuando lo marquen Devuelto).
       La venta queda anulada.`;
  $('#fpCancelarMsg').insertAdjacentHTML('beforebegin', `
    <div class="confirmar grave" id="fpConfCancelar" style="margin-top:0.471rem">
      <div class="conf-tit">¿Cancelar la venta ${esc(c.codigo)} entera?</div>
      <p class="conf-txt">${explico}</p>
      ${entregados.length ? `<p class="conf-txt"><b>Tiene algo entregado</b> (${esc(entregados.join(', '))}):
          la cancela sólo un administrador, y el equipo sigue en la calle hasta que lo marquen Devuelto.</p>` : ''}
      ${cobrado > 0.005 ? `<p class="conf-txt"><b>Es una venta con pago:</b> tiene ${num(cobrado)} cobrados.
          Cancelarla necesita la aprobación de un administrador, y <b>la plata no se reintegra sola</b>:
          después hay que anular los cobros («Ir a cobrar»).</p>` : ''}
      ${conPlata ? `<div class="chips-form"><label><input type="checkbox" id="fpCancRevisado">
          ${cobrado > 0.005 ? 'Entendí: la plata se devuelve aparte' : 'Entendí: lo entregado vuelve por Devuelto'}</label></div>` : ''}
      <label>Motivo <input id="fpCancMotivo" placeholder="Por qué se cancela (queda registrado)" autocomplete="off"></label>
      <div class="fila-acc" style="margin-top:0.471rem">
        <button class="b b-sec" type="button" id="fpCancNo">No</button>
        <button class="b b-peligro" type="button" id="fpCancSi">Sí, cancelar la venta</button>
      </div>
      <div id="fpCancConfMsg"></div>
    </div>`);
  $('#fpCancMotivo').focus();
  $('#fpCancNo').onclick = () => document.getElementById('fpConfCancelar')?.remove();
  $('#fpCancSi').onclick = () => cancelarVenta(conPlata);
};

async function cancelarVenta(conPlata: boolean){
  const motivo = ($('#fpCancMotivo').value || '').trim();
  if (!motivo){ aviso('#fpCancConfMsg', 'bad', 'Escribí el motivo.'); return; }
  if (conPlata && !$('#fpCancRevisado').checked){
    aviso('#fpCancConfMsg', 'bad', 'Tildá la casilla de la plata antes de confirmar.'); return;
  }
  const id = FP.id, cab = FP.cab;
  $('#fpCancSi').disabled = true;
  const { data, error } = await rpc('cancelar_venta', {
    p_pedido_id: id, p_motivo: motivo, p_confirmado: conPlata });
  if (FP?.id !== id) return;
  document.getElementById('fpConfCancelar')?.remove();
  for (const x of ['fpCancCorte', 'fpPedirCanc']) document.getElementById(x)?.remove();
  if (noContesto(error)){
    aviso('#fpCancelarMsg', 'warn', error.message + ' No se sabe si quedó cancelada: fijate en la lista antes de repetirlo.');
    releer();
    return;
  }
  if (error){
    aviso('#fpCancelarMsg', 'bad', error.message);
    if (!ofrecerPedirCorte({ despuesDe: '#fpCancelarMsg', id: 'fpCancCorte', prefijo: 'fpCancCorte',
          mensaje: error.message, refTipo: 'pedido', refId: id,
          comoSigue: 'Cuando te la den, volvé a apretar «Cancelar la venta».' }))
      ofrecerPedirCancelacion(error.message, id, cab.cliente_id);
    releer();
    return;
  }
  if (data.borrada){
    //  Ya no existe: de vuelta a la lista, con el resultado.
    cerrarVenta();
    cargarPedidos();
    aviso('#pedMsg', 'ok', data.mensaje);
    window.scrollTo({ top: 0 });
    return;
  }
  await releer();
  aviso('#fpCancelarMsg', Number(data.cobrado || 0) > 0.005 ? 'warn' : 'ok', data.mensaje);
}

//  La venta con plata cobrada (o la reserva): la autorización ahí mismo,
//  sobre la venta.
function ofrecerPedirCancelacion(mensaje: string, pedidoId: number, clienteId: number | null){
  const tipo = mensaje.includes(RECHAZO_VENTA_COBRADA) ? 'cancelacion_venta_cobrada'
    : mensaje.includes(RECHAZO_CANCELAR_RESERVA) ? 'cancelacion_reserva' : null;
  if (!tipo) return;
  $('#fpCancelarMsg').insertAdjacentHTML('afterend', `
    <div class="confirmar grave" id="fpPedirCanc" style="margin-top:0.471rem">
      <div class="conf-tit">Pedir autorización para cancelar ${tipo === 'cancelacion_reserva' ? 'la reserva' : 'la venta con pago'}</div>
      <p class="conf-txt">Se le avisa a un administrador. Cuando te respondan, volvé a apretar «Cancelar la venta».</p>
      <label>Por qué <input id="fpPedirCancMotivo" placeholder="Ej. el cliente se arrepintió y ya le devolvimos la plata"></label>
      <div class="fila-acc" style="margin-top:0.471rem">
        <button class="b b-pri" type="button" id="fpPedirCancOk">Pedir autorización</button>
      </div>
      <div id="fpPedirCancMsg"></div>
    </div>`);
  $('#fpPedirCancOk').onclick = async () => {
    const motivo = ($('#fpPedirCancMotivo').value || '').trim();
    limpiar('#fpPedirCancMsg');
    if (!motivo){ aviso('#fpPedirCancMsg', 'bad', 'Escribí por qué: es lo que va a leer quien autoriza.'); return; }
    $('#fpPedirCancOk').disabled = true;
    const { data, error } = await rpc('pedir_aprobacion', {
      p_tipo: tipo, p_motivo: motivo, p_monto: null,
      p_referencia_tipo: 'pedido', p_referencia_id: pedidoId,
      p_datos: clienteId == null ? {} : { cliente_id: clienteId } });
    if (!document.getElementById('fpPedirCanc')) return;
    if (!noContesto(error)) $('#fpPedirCancOk').disabled = false;
    if (error){ aviso('#fpPedirCancMsg', 'bad', error.message); return; }
    aviso('#fpPedirCancMsg', 'ok', data.mensaje);
    cargarAprobaciones();
  };
}

async function cambiarDescuento(itemId: number){
  limpiar('#fpItemsMsg');
  document.getElementById('fpPedirDesc')?.remove();
  const inp = $(`#tblFpItems [data-desc="${itemId}"]`);
  const desc = Number(inp?.value) || 0;
  const it = FP.items.find((x: any) => x.id === itemId);
  const { data, error } = await rpc('cambiar_descuento_item', { p_item_id: itemId, p_descuento: desc });
  if (noContesto(error)){ aviso('#fpItemsMsg', 'warn', error.message + ' Fijate si quedó antes de repetirlo.'); releer(); return; }
  if (error){
    aviso('#fpItemsMsg', 'bad', error.message);
    if (it) ofrecerPedirDescuento('#fpItemsMsg', error.message, it.producto_id, desc, itemId);
    return;
  }
  await releer();
  aviso('#fpItemsMsg', Number(data.a_favor || 0) > 0 ? 'warn' : 'ok', data.mensaje);
}

//  El descuento que pasa el máximo: se pide la autorización ahí mismo, por
//  ese producto y ese monto (al agregarlo, sin referencia, como en el alta;
//  al cambiarlo, sobre el renglón).
function ofrecerPedirDescuento(despuesDe: string, mensaje: string, productoId: number,
                               monto: number, itemId: number | null){
  document.getElementById('fpPedirDesc')?.remove();
  if (!mensaje.includes(RECHAZO_DESCUENTO) || mensaje.includes(RECHAZO_DESCUENTO_PEDIDO)) return;
  if (!(monto > 0)) return;
  $(despuesDe).insertAdjacentHTML('afterend', `
    <div class="confirmar grave" id="fpPedirDesc" style="margin-top:0.471rem">
      <div class="conf-tit">Pedir autorización por el descuento</div>
      <p class="conf-txt">Se le avisa a quien puede autorizarlo. Cuando te respondan, volvé a apretar el mismo botón.
         Te lo tienen que autorizar por el descuento entero (${num(monto)}).</p>
      <label>Por qué <input id="fpDescMotivo" placeholder="Ej. el cliente lleva cuatro y lo tenemos que igualar"></label>
      <div class="fila-acc" style="margin-top:0.471rem">
        <button class="b b-pri" type="button" id="fpDescOk">Pedir ${num(monto)}</button>
      </div>
      <div id="fpDescMsg"></div>
    </div>`);
  $('#fpDescOk').onclick = async () => {
    const motivo = ($('#fpDescMotivo').value || '').trim();
    limpiar('#fpDescMsg');
    if (!motivo){ aviso('#fpDescMsg', 'bad', 'Escribí por qué: es lo que va a leer quien autoriza.'); return; }
    $('#fpDescOk').disabled = true;
    const { data, error } = await rpc('pedir_aprobacion', {
      p_tipo: 'descuento_item', p_motivo: motivo, p_monto: monto,
      p_referencia_tipo: itemId == null ? null : 'pedido_item',
      p_referencia_id: itemId,
      p_datos: { cliente_id: FP.cab.cliente_id, producto_id: productoId } });
    if (!noContesto(error)) $('#fpDescOk').disabled = false;
    if (error){ aviso('#fpDescMsg', 'bad', error.message); return; }
    aviso('#fpDescMsg', 'ok', data.mensaje);
    cargarAprobaciones();
  };
}

// ---------- los datos de la venta ----------
const CAMPOS_ENVIO: [string, string, string][] = [
  ['direccion', '#fpDir', 'direccion'], ['barrio', '#fpBarrio', 'barrio'],
  ['telefono', '#fpTel', 'telefono_contacto'], ['horario', '#fpHorario', 'horario_texto']];

function pintarDatos(){
  const p = FP.ped, sit = FP.sit, puedo = edita(p);
  const enMoto = FP.cab.tipo_entrega === 'propio';
  $('#fpPrioridad').value = p.prioridad || 'normal';
  $('#fpNotas').value = p.notas || '';
  for (const [, sel, col] of CAMPOS_ENVIO) $(sel).value = p[col] || '';
  pintarZona();
  $('#fpEnvio').classList.toggle('oculto', !enMoto);
  //  Lo que se puede tocar según la situación (la base lo vuelve a mirar).
  const notas = puedo && sit !== 'anulada';
  const prio = puedo && sit === 'intacta';
  const envio = puedo && enMoto && (sit === 'intacta' || sit === 'en_deposito');
  $('#fpNotas').disabled = !notas;
  $('#fpPrioridad').disabled = !prio;
  $$('#fpEnvio input, #fpEnvio select').forEach((x: any) => { x.disabled = !envio; });
  $('#btnFpGuardar').classList.toggle('oculto', !notas);
  $('#fpSoloLectura').textContent = !puedo
    ? (puede('pedido','editar') ? 'Sólo lectura: esta venta es de otro vendedor.' : 'Sólo lectura: no tenés permiso para editar pedidos.')
    : sit === 'anulada' ? 'Sólo lectura: la venta está anulada.' : '';
  $('#formFp').classList.remove('oculto');
  if (envio){
    const id = FP.id;
    asegurarZonas().then(() => { if (FP?.id === id) pintarZona(); });
  }
}

function pintarZona(){
  if (!FP?.ped) return;
  const zonas = zonasLeidas(), actual = FP.ped.zona_id;
  //  La que tiene aunque no esté en la lista: si no, quedaría elegida «Sin
  //  zona» sin que nadie la elija, y se guardaría.
  $('#fpZona').innerHTML = `<option value="">${ERROR_ZONAS ? 'Sin zona — no se pudieron leer' : 'Sin zona'}</option>` +
    (actual != null && !zonas.some(z => z.id === actual)
      ? `<option value="${actual}">${ERROR_ZONAS ? 'la que tiene (no se pudieron leer las zonas)'
                                                 : 'la que tiene (desactivada)'}</option>` : '') +
    zonas.map(z => `<option value="${z.id}">${esc(z.nombre)}</option>`).join('');
  $('#fpZona').value = actual == null ? '' : String(actual);
}

$('#formFp').onsubmit = async e => {
  e.preventDefault();
  limpiar('#fpGuardarMsg');
  if (!FP?.ped) return;
  const p = FP.ped, d: Record<string, unknown> = {};
  if (!$('#fpNotas').disabled && ($('#fpNotas').value || '').trim() !== (p.notas || '')) d.notas = $('#fpNotas').value;
  if (!$('#fpPrioridad').disabled && $('#fpPrioridad').value !== p.prioridad) d.prioridad = $('#fpPrioridad').value;
  if (!$('#fpDir').disabled){
    for (const [k, sel, col] of CAMPOS_ENVIO)
      if (($(sel).value || '').trim() !== (p[col] || '')) d[k] = $(sel).value;
    const z = $('#fpZona').value ? Number($('#fpZona').value) : null;
    if (z !== (p.zona_id ?? null)) d.zona_id = z;
  }
  if (!Object.keys(d).length){ aviso('#fpGuardarMsg', 'ok', 'No cambiaste nada.'); return; }
  const b = $('#btnFpGuardar'); b.disabled = true;
  const { data, error } = await rpc('editar_pedido', { p_pedido_id: FP.id, p_datos: d as any });
  b.disabled = false;
  if (noContesto(error)){
    aviso('#fpGuardarMsg', 'warn', error.message + ' No se sabe si quedó guardado: entrá de nuevo y fijate.');
    return;
  }
  if (error){ aviso('#fpGuardarMsg', 'bad', error.message); return; }
  await releer();
  aviso('#fpGuardarMsg', 'ok', data.mensaje);
};

// ---------- cobros e historial ----------
async function leerCobros(turno: number){
  const id = FP.id;
  const { data, error } = await pedir(sb.from('v_cobros')
    .select('id,ocurrido_en,medio_pago,moneda,monto,monto_usd,anulado,es_anulacion,motivo')
    .eq('pedido_id', id).order('ocurrido_en'));
  if (turno !== TURNO) return;
  const ir = `<div class="fila-acc" style="justify-content:flex-start;margin-top:0.471rem">
      <button class="b b-sec" type="button" id="fpIrCobros">Ir a cobrar</button></div>`;
  if (error){
    $('#fpCobros').innerHTML = `<p class="vacio">No se pudieron leer los cobros (${esc(error.message)}). ` +
      'No quiere decir que no tenga ninguno.</p>' + ir;
  } else {
    const cs = (data || []) as any[];
    $('#fpCobros').innerHTML = (cs.length
      ? `<div class="tw"><table><thead><tr><th>Cuándo</th><th>Medio</th><th class="num">Monto</th><th></th></tr></thead><tbody>${
          cs.map(x => `<tr><td>${esc(fecha(x.ocurrido_en))}</td><td>${esc(x.medio_pago || '—')}</td>
            <td class="num">${esc(x.moneda || '')} ${num(Number(x.monto))}</td>
            <td>${x.es_anulacion ? '<span class="chip c-bad">anulación</span>'
                 : x.anulado ? '<span class="chip c-warn">anulado</span>' : ''}</td></tr>`).join('')}</tbody></table></div>`
      : '<p class="vacio">Todavía no tiene cobros.</p>') + ir;
  }
  $('#fpIrCobros').onclick = () => { const c = FP.cab; cerrarVenta(); irACobros(c.id, c.codigo); };
}

const QUE: Record<string, string> = {
  confirmacion: 'Pedido confirmado', datos: 'Datos', datos_envio: 'Envío',
  cambio_entrega: 'Forma de entrega', item_agregado: 'Producto agregado',
  item_quitado: 'Producto quitado', descuento: 'Descuento', venta_cancelada: 'Venta cancelada',
  cambio_estado: 'Paso', deshacer: 'Deshecho', reversion_con_revision: 'Vuelta atrás',
};

async function leerHistorial(turno: number){
  const id = FP.id;
  const [ev, us, es] = await Promise.all([
    pedir(sb.from('pedido_eventos').select('id,pedido_item_id,tipo,estado_id,motivo,datos,usuario_id,ocurrido_en')
      .eq('pedido_id', id).order('ocurrido_en', { ascending: false }).order('id', { ascending: false })),
    pedir(sb.from('usuarios').select('id,nombre')),
    pedir(sb.from('estados_item').select('id,nombre'))]);
  if (turno !== TURNO) return;
  if (ev.error){
    aviso('#fpHistMsg', 'bad', 'No se pudo leer el historial: ' + ev.error.message +
      '. No quiere decir que no tenga cambios.');
    return;
  }
  if (us.error) aviso('#fpHistMsg', 'warn', 'No se pudieron leer los nombres de quién hizo cada ' +
    'cambio (' + us.error.message + '): se muestra su número.');
  else limpiar('#fpHistMsg');
  const nombres = new Map(((us.data || []) as any[]).map(u => [u.id, u.nombre]));
  const estados = new Map(((es.data || []) as any[]).map(u => [u.id, u.nombre]));
  const prod = new Map(FP.items.map((i: any) => [i.id, i.producto]));
  const txt = (v: unknown) => v == null || v === '' ? '(vacío)' : `«${v}»`;
  const linea = (x: any) => {
    if (x.tipo === 'datos' && x.datos?.cambios)
      return (x.datos.cambios as any[]).map(c =>
        `<div>${esc(c.campo)}: ${esc(txt(c.antes))} → ${esc(txt(c.despues))}</div>`).join('');
    const sobre = x.pedido_item_id && prod.get(x.pedido_item_id) ? `${prod.get(x.pedido_item_id)}: ` : '';
    const paso = x.estado_id && estados.get(x.estado_id) ? `→ ${estados.get(x.estado_id)}` : '';
    return `<div><b>${esc(QUE[x.tipo] || x.tipo)}</b> ${esc(sobre)}${esc(paso)}${
      x.motivo ? (paso ? ' · ' : '') + esc(x.motivo) : ''}</div>`;
  };
  const filas = (ev.data || []) as any[];
  $('#fpHist').innerHTML = filas.length
    ? `<div class="tw"><table><thead><tr><th>Cuándo</th><th>Quién</th><th>Qué</th></tr></thead><tbody>${
        filas.map(x => `<tr><td>${esc(fecha(x.ocurrido_en))}</td>
          <td>${esc(x.usuario_id == null ? '—' : nombres.get(x.usuario_id) ?? `#${x.usuario_id}`)}</td>
          <td>${linea(x)}</td></tr>`).join('')}</tbody></table></div>`
    : '<p class="vacio">Todavía no hay nada anotado.</p>';
}
